<script>
import options from './SignUpForm.options'
export default options
</script>

<template>
  <SuccessPage v-if="showReceipt"></SuccessPage>
  <article
    v-else
    class="kb-sign-up-form"
    :class="{ 'kb-sign-up-form--submitting': isSubmitting }"
  >
    <section class="kb-sign-up-form__hero">
      <p class="kb-sign-up-form__hero__small-title">
        {{
          getLabel({ labelCollection: 'signUpForm', labelKey: 'signupHeader' })
        }}
      </p>
      <h1 class="kb-sign-up-form__hero__title">
        {{
          decodeHtml(getLabel({
            labelCollection: 'signUpForm',
            labelKey: 'signupHeaderMain'
          }))
        }}
      </h1>
    </section>
    <div class="kb-sign-up-form__hero__curve">
      <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z"
        />
      </svg>
    </div>
    <section class="kb-sign-up-form__content-container" aria-live="polite">
      <form method="post" class="kb-sign-up-form__kb-form kb-forms">
        <label for="firstName" class="kb-sign-up-form__kb-form__label">
          {{
            getLabel({
              labelCollection: 'signUpForm',
              labelKey: 'signupLabelFirstName'
            })
          }}
        </label>
        <input
          id="firstName"
          v-model="firstName"
          @keydown.tab="tabTrap"
          data-order="first"
          name="Fornavn"
          type="text"
          class="kb-sign-up-form__kb-form__input"
          :placeholder="getLabel({labelCollection: 'signUpForm', labelKey: 'signupLabelFirstName'})"
          required
        />
        <p
          class="kb-forms Form__Element__ValidationError"
          v-if="!firstNameFilled"
        >
          {{
            getLabel({
              labelCollection: 'signUpForm',
              labelKey: 'validationLabelFirstName'
            })
          }}
        </p>

        <label for="lastName" class="kb-sign-up-form__kb-form__label"
          >{{
            getLabel({
              labelCollection: 'signUpForm',
              labelKey: 'signupLabelLastName'
            })
          }}
        </label>
        <input
          id="lastName"
          v-model="lastName"
          name="Efternavn"
          type="text"
          class="kb-sign-up-form__kb-form__input"
          :placeholder="getLabel({labelCollection: 'signUpForm', labelKey: 'signupLabelLastName'})"
          required
        />
        <p
          class="kb-forms Form__Element__ValidationError"
          v-if="!lastNameFilled"
        >
          {{
            getLabel({
              labelCollection: 'signUpForm',
              labelKey: 'validationLabelLastName'
            })
          }}
        </p>

        <label for="phone" class="kb-sign-up-form__kb-form__label"
          >{{
            getLabel({ labelCollection: 'signUpForm', labelKey: 'signupPhone' })
          }}
        </label>
        <input
          id="phone"
          v-model="phone"
          name="Telefon"
          type="text"
          class="kb-sign-up-form__kb-form__input"
          :placeholder="getLabel({ labelCollection: 'signUpForm', labelKey: 'signupPhone'})"
          required
        />
        <p class="kb-forms Form__Element__ValidationError" v-if="!isValidPhone">
          {{
            getLabel({
              labelCollection: 'signUpForm',
              labelKey: 'validationPhone'
            })
          }}
        </p>

        <label for="email" class="kb-sign-up-form__kb-form__label"
          >{{
            getLabel({ labelCollection: 'signUpForm', labelKey: 'signupEmail' })
          }}
        </label>
        <input
          id="email"
          v-model="email"
          name="Email"
          type="email"
          class="kb-sign-up-form__kb-form__input"
          :placeholder="getLabel({ labelCollection: 'signUpForm', labelKey: 'signupEmail' })"
          required
        />
        <p
          class="kb-forms Form__Element__ValidationError kb-sign-up-form__validation-error"
          v-if="!isValidEmail"
        >
          {{
            getLabel({
              labelCollection: 'signUpForm',
              labelKey: 'validationEmail'
            })
          }}
        </p>

        <div class="kb-sign-up-form__kb-form__checkbox-container">
          <input
            id="signup"
            v-model="consent"
            type="checkbox"
            name="signup"
            class="kb-sign-up-form__kb-form__radio-input"
            required
          />
          <label for="signup" class="kb-sign-up-form__kb-form__radio-label">{{
            getLabel({
              labelCollection: 'signUpForm',
              labelKey: 'signupConsent'
            })
          }}</label>
        </div>
        <p
          class="kb-forms Form__Element__ValidationError kb-sign-up-form__validation-error"
          v-if="!consentChecked"
        >
          {{
            getLabel({
              labelCollection: 'signUpForm',
              labelKey: 'validationConsent'
            })
          }}
        </p>
      </form>

      <p id="signupInfo" class="kb-sign-up-form__signup-info">
        {{
          getLabel({
            labelCollection: 'signUpForm',
            labelKey: 'signupParagraph'
          })
        }}
      </p>
      <p
        class="kb-forms Form__Element__ValidationError kb-sign-up-form__validation-error"
        v-if="signUpFailed"
        role="alert"
      >
        {{ getLabel({ labelCollection: 'signUpForm', labelKey: 'signupError' }) }}
      </p>
      <div class="kb-sign-up-form__button-wrapper">
        <button
          @click="onSubmit"
          id="submit"
          name="submit"
          data-order="last"
          @keydown.tab="tabTrap"
          type="submit"
          value=""
          class="kb-button kb-button--full-color-spot"
          aria-describedby="signupInfo"
        >
          {{
            getLabel({
              labelCollection: 'signUpForm',
              labelKey: 'signupButton'
            })
          }}
        </button>
      </div>
      <div class="kb-sign-up-form__privacy-policy-info">
        <p
          class="kb-sign-up-form__privacy-policy-info__text"
          v-html="
            getLabel({ labelCollection: 'signUpForm', labelKey: 'privacyText' })
          "
        ></p>
      </div>
    </section>

    <template v-if="isSubmitting">
      <div class="kb-spinner-container">
        <div class="kb-spinner-container__spinner"></div>
      </div>
    </template>
  </article>
</template>
